<op-autocompleter
  data-qa-selector="tp-add-assignee"
  (change)="selectUser($event)"
  [fetchDataDirectly]="true"
  [getOptionsFn]="getOptionsFn"
  resource="user"
  appendTo="body"
></op-autocompleter>
